import router from '~/core/router';
import { CancellationRoutePolyllmChat } from '~/modules/cancellation';

router.addPrivateRoutes([CancellationRoutePolyllmChat]);
